import { isNil } from "lodash";
import Item from "../../../core/items/Item";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import MultiLabelItem, { ItemLabel } from "../../../core/items/MultiLabelItem";


interface MedallionItemProps {
    image: string
    id: string
    title?: string
    hideLabel?: true
    mixedpool?: true
    isObtained?: boolean
    setIsObtained?: (v: boolean) => void
    labelIndex?: number
    setLabelIndex?: (v: number) => void
    item?: ItemLightDto
    updateItem?: (v: ItemLightDto) => void
}

const MedallionItem = (props: MedallionItemProps) => {

    let { image, hideLabel } = props;

    if (hideLabel)
        return <Item
            id={props.id}
            image={image}
            title={props.title ?? ""}
            isObtained={props.isObtained }
            setIsObtained={props.setIsObtained}
        />

    if(props.mixedpool)
        return <MultiLabelItem
        id={props.id}
        image={image}
        title={"Light Medallion"}
        labels={MixedPoolLabel}
        hideLabel={hideLabel}
        item={props.item}
        updateItem={props.updateItem}
        isObtained={props.isObtained ? 1 : 0}
        setIsObtained={(v) => {if(!isNil(props.setIsObtained))props.setIsObtained(v > 0)}}
        indexLabel={props.labelIndex}
        setIndexLabel={props.setLabelIndex}
        />

    return <MultiLabelItem
        id={props.id}
        image={image}
        title={"Light Medallion"}
        labels={[{label: "Free", color: "white"},{label: "Deku", color: "#6BF25F"},  {label: "DC", color: "#ED5555"},  {label: "Jabu", color: "#2deeff"}, {label: "Forest", color: "#6BF25F"},  {label: "Fire", color: "#ED5555"},  {label: "Water", color: "#2deeff"},  {label: "Shadow", color: "#DA5FF2"},  {label: "Spirit", color: "orange"}]}
        hideLabel={hideLabel}
        item={props.item}
        updateItem={props.updateItem}
        isObtained={props.isObtained ? 1 : 0}
        setIsObtained={(v) => {if(!isNil(props.setIsObtained))props.setIsObtained(v > 0)}}
        indexLabel={props.labelIndex}
        setIndexLabel={props.setLabelIndex}
    />
}

export default MedallionItem



export const MixedPoolLabel: Array<ItemLabel> = [
    {label: "Free", color: "white"},
    {label: "DCol", color: "orange", groupKey: "Desert"},
    {label: "GTG", color: "orange", groupKey: "Desert"},
    {label: "Deku", color: "rgb(0, 166, 71)", groupKey: "Forest"},
    {label: "DC", color: "red", groupKey: "Mountain"},
    {label: "DMC", color: "red", groupKey: "Mountain"},
    {label: "DMT", color: "red", groupKey: "Mountain"},
    {label: "Fire", color: "red", groupKey: "Mountain"},
    {label: "Forest", color: "rgb(0, 166, 71)", groupKey: "Forest"},
    {label: "Ganon", color: "black", groupKey: "Ganon"},
    {label: "GC", color: "red", groupKey: "Mountain"},
    {label: "GV", color: "orange", groupKey: "Desert"},
    {label: "GF", color: "orange", groupKey: "Desert"},
    {label: "GY", color: "rgb(207, 137, 211)", groupKey: "Kak"},
    {label: "HC", color: "yellow", groupKey: "Hyrule"},
    {label: "HF", color: "yellow", groupKey: "Hyrule"},
    {label: "ICE", color: "lightblue", groupKey: "Zora"},
    {label: "Jabu", color: "lightblue", groupKey: "Zora"},
    {label: "KF", color: "rgb(0, 166, 71)", groupKey: "Forest"},
    {label: "Kak", color: "rgb(207, 137, 211)", groupKey: "Kak"},
    {label: "Botw", color: "rgb(207, 137, 211)", groupKey: "Kak"},
    {label: "LH", color: "lightblue", groupKey: "Zora"},
    {label: "LLR", color: "yellow", groupKey: "Hyrule"},
    {label: "LW", color: "rgb(0, 166, 71)", groupKey: "Forest"},
    {label: "LW_Bridge", color: "rgb(0, 166, 71)", groupKey: "Forest"},
    {label: "MKT", color: "yellow", groupKey: "Hyrule"},
    {label: "MKT_Bridge", color: "yellow", groupKey: "Hyrule"},
    {label: "OGC", color: "black", groupKey: "Ganon"},
    {label: "SFM", color: "rgb(0, 166, 71)", groupKey: "Forest"},
    {label: "Shadow", color: "rgb(207, 137, 211)", groupKey: "Kak"},
    {label: "Spirit", color: "orange", groupKey: "Desert"},
    {label: "HW", color: "orange", groupKey: "Desert"},
    {label: "Water", color: "lightblue", groupKey: "Zora"},
    {label: "ZD", color: "lightblue", groupKey: "Zora"},
    {label: "ZR", color: "lightblue", groupKey: "Zora"},
    {label: "ZF", color: "lightblue", groupKey: "Zora"},
]
